const ShawContract = window.ShawContract || {};
const globalUserObjectJSON = document.getElementById('global-user').value;
const globalUserObject = globalUserObjectJSON && JSON.parse(globalUserObjectJSON);

ShawContract.userObject = globalUserObject;
window.ShawContract = ShawContract;
